import type { MediaTitle } from "@/types/media";

export const mediaList: MediaTitle[] = [
  {
    id: "dune-part-two",
    type: "movie",
    title: "沙丘2",
    originalTitle: "Dune: Part Two",
    year: 2024,
    region: "欧美",
    country: "美国",
    genres: ["科幻", "冒险", "动作"],
    rating: 8.3,
    director: "丹尼斯·维伦纽瓦",
    cast: ["提莫西·查拉梅", "赞达亚", "丽贝卡·弗格森", "哈维尔·巴登"],
    duration: "166分钟",
    poster: "https://readdy.ai/api/search-image?query=epic%20science%20fiction%20movie%20poster%20of%20a%20lone%20figure%20in%20dark%20hooded%20cloak%20walking%20across%20vast%20orange%20desert%20sand%20dunes%20under%20an%20enormous%20sun%2C%20cinematic%20dramatic%20lighting%2C%20film%20grain%2C%20vertical%20poster%2C%20high%20detail&width=600&height=900&seq=dune-two-poster&orientation=portrait",
    backdrop: "https://readdy.ai/api/search-image?query=epic%20cinematic%20wide%20shot%20of%20colossal%20desert%20sand%20dunes%20at%20golden%20hour%20with%20two%20tiny%20riders%2C%20science%20fiction%20atmosphere%2C%20dramatic%20warm%20light%2C%20film%20texture%2C%20high%20detail&width=1920&height=1080&seq=dune-two-backdrop&orientation=landscape",
    synopsis: "保罗·厄崔迪与契妮及弗雷曼人并肩作战，踏上复仇之路。他必须在挚爱与已知宇宙的命运之间做出抉择，并竭力阻止只有他能预见的可怕未来。",
    heat: 982000,
    featured: true,
    tags: ["史诗", "沙丘宇宙", "大银幕"],
  },
  {
    id: "oppenheimer",
    type: "movie",
    title: "奥本海默",
    originalTitle: "Oppenheimer",
    year: 2023,
    region: "欧美",
    country: "美国",
    genres: ["传记", "剧情", "历史"],
    rating: 8.9,
    director: "克里斯托弗·诺兰",
    cast: ["基里安·墨菲", "艾米莉·布朗特", "马特·达蒙", "小罗伯特·唐尼"],
    duration: "180分钟",
    poster: "https://readdy.ai/api/search-image?query=dramatic%20biographical%20movie%20poster%20of%20a%20serious%20man%20in%20a%20fedora%20hat%20silhouetted%20against%20a%20glowing%20orange%20mushroom%20cloud%2C%20dark%20moody%20tones%2C%20vertical%20poster%20composition%2C%20film%20grain%2C%20high%20detail&width=600&height=900&seq=oppenheimer-poster&orientation=portrait",
    backdrop: "https://readdy.ai/api/search-image?query=cinematic%20dark%20laboratory%20interior%20with%20warm%20amber%20lighting%2C%20mid%20century%20scientific%20atmosphere%2C%20tense%20dramatic%20mood%2C%20film%20texture%2C%20high%20detail&width=1920&height=1080&seq=oppenheimer-backdrop&orientation=landscape",
    synopsis: "本片讲述“原子弹之父”罗伯特·奥本海默的故事。他领导曼哈顿计划研制出世界上第一颗原子弹，却在战后陷入关于科学、权力与道德的深刻拷问。",
    heat: 921000,
    featured: true,
    tags: ["诺兰", "传记", "获奖无数"],
  },
  {
    id: "spider-verse",
    type: "movie",
    title: "蜘蛛侠：纵横宇宙",
    originalTitle: "Spider-Man: Across the Spider-Verse",
    year: 2023,
    region: "欧美",
    country: "美国",
    genres: ["动画", "动作", "冒险"],
    rating: 8.5,
    director: "华金·多斯·桑托斯",
    cast: ["沙梅克·摩尔", "海莉·斯坦菲尔德", "奥斯卡·伊萨克"],
    duration: "140分钟",
    poster: "https://readdy.ai/api/search-image?query=vibrant%20animated%20comic%20style%20movie%20poster%20of%20a%20superhero%20masked%20figure%20leaping%20through%20a%20colorful%20urban%20skyline%20with%20neon%20splashes%2C%20bold%20graphic%20art%2C%20vertical%20poster%20composition%2C%20high%20detail&width=600&height=900&seq=spiderverse-poster&orientation=portrait",
    backdrop: "https://readdy.ai/api/search-image?query=stylized%20animated%20city%20skyline%20at%20dusk%20with%20dramatic%20comic%20book%20color%20splashes%20and%20dynamic%20visual%20energy%2C%20cinematic%20wide%20shot%2C%20high%20detail&width=1920&height=1080&seq=spiderverse-backdrop&orientation=landscape",
    synopsis: "迈尔斯·莫拉莱斯穿越多元宇宙，与格温·斯泰西及新队友相遇，却因如何应对新的威胁而与其他蜘蛛侠产生分歧，被迫重新定义英雄的意义。",
    heat: 876000,
    featured: true,
    tags: ["动画", "多元宇宙", "视觉炸裂"],
  },
  {
    id: "john-wick-4",
    type: "movie",
    title: "疾速追杀4",
    originalTitle: "John Wick: Chapter 4",
    year: 2023,
    region: "欧美",
    country: "美国",
    genres: ["动作", "惊悚", "犯罪"],
    rating: 7.9,
    director: "查德·斯塔尔斯基",
    cast: ["基努·里维斯", "甄子丹", "劳伦斯·菲什伯恩"],
    duration: "169分钟",
    poster: "https://readdy.ai/api/search-image?query=stylish%20action%20movie%20poster%20of%20a%20lone%20man%20in%20a%20sharp%20black%20suit%20holding%20a%20pistol%20in%20rain%20soaked%20neon%20city%20street%2C%20moody%20blue%20tones%20with%20amber%20highlights%2C%20vertical%20poster%2C%20high%20detail&width=600&height=900&seq=johnwick4-poster&orientation=portrait",
    backdrop: "https://readdy.ai/api/search-image?query=rainy%20neon%20lit%20metropolitan%20street%20at%20night%20with%20reflective%20wet%20asphalt%2C%20moody%20cinematic%20action%20atmosphere%2C%20wide%20shot%2C%20high%20detail&width=1920&height=1080&seq=johnwick4-backdrop&orientation=landscape",
    synopsis: "约翰·威克在新一轮的追杀中直面高桌会的最高权力，跨越纽约、巴黎与大阪，只为赢得最后的自由。代价，是他必须在一场决斗中赌上一切。",
    heat: 764000,
    tags: ["动作", "枪战", "基努"],
  },
  {
    id: "avatar-way-of-water",
    type: "movie",
    title: "阿凡达：水之道",
    originalTitle: "Avatar: The Way of Water",
    year: 2022,
    region: "欧美",
    country: "美国",
    genres: ["科幻", "冒险", "动作"],
    rating: 7.8,
    director: "詹姆斯·卡梅隆",
    cast: ["萨姆·沃辛顿", "佐伊·索尔达娜", "西格妮·韦弗"],
    duration: "192分钟",
    poster: "https://readdy.ai/api/search-image?query=lush%20science%20fiction%20movie%20poster%20of%20tall%20blue%20skinned%20alien%20figures%20standing%20amid%20glowing%20turquoise%20water%20and%20bioluminescent%20plants%2C%20vibrant%20cinematic%20colors%2C%20vertical%20poster%2C%20high%20detail&width=600&height=900&seq=avatar2-poster&orientation=portrait",
    backdrop: "https://readdy.ai/api/search-image?query=stunning%20alien%20ocean%20world%20with%20turquoise%20glowing%20water%20and%20floating%20islands%20at%20sunset%2C%20cinematic%20epic%20scale%2C%20wide%20shot%2C%20high%20detail&width=1920&height=1080&seq=avatar2-backdrop&orientation=landscape",
    synopsis: "杰克·萨利与奈蒂莉组建家庭后，为躲避人类的追杀，举家逃离到潘多拉星球的海洋部落。他们必须学会与水共生，并再次为家园而战。",
    heat: 812000,
    tags: ["科幻", "海洋", "视觉奇观"],
  },
  {
    id: "everything-everywhere",
    type: "movie",
    title: "瞬息全宇宙",
    originalTitle: "Everything Everywhere All at Once",
    year: 2022,
    region: "欧美",
    country: "美国",
    genres: ["科幻", "喜剧", "剧情"],
    rating: 7.6,
    director: "关家永 / 丹尼尔·施耐特",
    cast: ["杨紫琼", "关继威", "杰米·李·柯蒂斯"],
    duration: "139分钟",
    poster: "https://readdy.ai/api/search-image?query=surreal%20vibrant%20movie%20poster%20of%20a%20woman%20surrounded%20by%20swirling%20kaleidoscopic%20colorful%20fragments%20and%20glowing%20portals%2C%20playful%20chaotic%20energy%2C%20vertical%20poster%2C%20high%20detail&width=600&height=900&seq=eeaao-poster&orientation=portrait",
    backdrop: "https://readdy.ai/api/search-image?query=psychedelic%20kaleidoscopic%20swirl%20of%20colorful%20lights%20and%20shapes%20representing%20parallel%20universes%2C%20surreal%20cinematic%20abstract%20composition%2C%20wide%20shot%2C%20high%20detail&width=1920&height=1080&seq=eeaao-backdrop&orientation=landscape",
    synopsis: "一位平凡的华裔洗衣店老板娘，在报税当天意外被卷入多元宇宙的危机。她必须连接平行世界中的无数个自己，才能真正理解并拯救自己的家庭。",
    heat: 655000,
    tags: ["多元宇宙", "家庭", "奥斯卡"],
  },
  {
    id: "no-time-to-die",
    type: "movie",
    title: "007：无暇赴死",
    originalTitle: "No Time to Die",
    year: 2021,
    region: "欧美",
    country: "英国",
    genres: ["动作", "冒险", "惊悚"],
    rating: 7.0,
    director: "凯瑞·福永",
    cast: ["丹尼尔·克雷格", "拉米·马雷克", "蕾雅·赛杜"],
    duration: "163分钟",
    poster: "https://readdy.ai/api/search-image?query=elegant%20spy%20thriller%20movie%20poster%20of%20a%20man%20in%20a%20tuxedo%20holding%20a%20pistol%20silhouetted%20against%20smoky%20golden%20abstract%20swirls%2C%20sophisticated%20cinematic%20tones%2C%20vertical%20poster%2C%20high%20detail&width=600&height=900&seq=bond-nttd-poster&orientation=portrait",
    backdrop: "https://readdy.ai/api/search-image?query=luxurious%20smoky%20gold%20and%20teal%20abstract%20cinematic%20background%20with%20dramatic%20lighting%20and%20elegant%20spy%20thriller%20mood%2C%20wide%20shot%2C%20high%20detail&width=1920&height=1080&seq=bond-nttd-backdrop&orientation=landscape",
    synopsis: "詹姆斯·邦德在隐退后被迫重返战场，营救一位神秘科学家，却卷入一场牵扯生化武器的惊天阴谋，最终迎来属于他的终章。",
    heat: 601000,
    tags: ["007", "特工", "谢幕"],
  },
  {
    id: "barbie",
    type: "movie",
    title: "芭比",
    originalTitle: "Barbie",
    year: 2023,
    region: "欧美",
    country: "美国",
    genres: ["喜剧", "奇幻", "冒险"],
    rating: 6.9,
    director: "格蕾塔·葛韦格",
    cast: ["玛格特·罗比", "瑞恩·高斯林", "亚美莉卡·费雷拉"],
    duration: "114分钟",
    poster: "https://readdy.ai/api/search-image?query=glossy%20playful%20movie%20poster%20of%20a%20blonde%20doll%20figure%20in%20a%20bright%20pink%20dress%20against%20a%20bubblegum%20pink%20backdrop%20with%20sparkles%2C%20pop%20art%20style%2C%20vertical%20poster%2C%20high%20detail&width=600&height=900&seq=barbie-poster&orientation=portrait",
    backdrop: "https://readdy.ai/api/search-image?query=whimsical%20bright%20pink%20dream%20house%20world%20with%20glossy%20plastic%20surfaces%20and%20playful%20pastel%20color%20palette%2C%20cinematic%20wide%20shot%2C%20high%20detail&width=1920&height=1080&seq=barbie-backdrop&orientation=landscape",
    synopsis: "生活在理想国度的芭比，某天发现自己的世界出现了裂痕。她与肯一同前往真实世界寻找答案，却发现现实远比想象中复杂而有趣。",
    heat: 588000,
    tags: ["喜剧", "粉色风暴", "流行文化"],
  },
  {
    id: "parasite",
    type: "movie",
    title: "寄生虫",
    originalTitle: "기생충",
    year: 2019,
    region: "日韩",
    country: "韩国",
    genres: ["剧情", "惊悚", "喜剧"],
    rating: 8.8,
    director: "奉俊昊",
    cast: ["宋康昊", "李善均", "曹如晶", "崔宇植"],
    duration: "132分钟",
    poster: "https://readdy.ai/api/search-image?query=tense%20arthouse%20movie%20poster%20of%20a%20family%20of%20four%20standing%20in%20a%20shadowy%20modern%20house%20corridor%2C%20moody%20green%20and%20gray%20tones%2C%20social%20thriller%20atmosphere%2C%20vertical%20poster%2C%20high%20detail&width=600&height=900&seq=parasite-poster&orientation=portrait",
    backdrop: "https://readdy.ai/api/search-image?query=minimalist%20modern%20affluent%20house%20with%20large%20glass%20windows%20and%20manicured%20garden%2C%20cold%20clean%20cinematic%20lighting%2C%20wide%20shot%2C%20high%20detail&width=1920&height=1080&seq=parasite-backdrop&orientation=landscape",
    synopsis: "住在半地下室、生活拮据的金家人，通过精心设计的计划一步步渗透进富贵人家。两个阶层的碰撞，最终演变成一场无法收拾的悲剧。",
    heat: 903000,
    featured: true,
    tags: ["金棕榈", "阶层", "韩国电影"],
  },
  {
    id: "train-to-busan",
    type: "movie",
    title: "釜山行",
    originalTitle: "부산행",
    year: 2016,
    region: "日韩",
    country: "韩国",
    genres: ["恐怖", "动作", "惊悚"],
    rating: 8.6,
    director: "延尚昊",
    cast: ["孔刘", "郑有美", "马东锡", "金秀安"],
    duration: "118分钟",
    poster: "https://readdy.ai/api/search-image?query=tense%20zombie%20horror%20movie%20poster%20of%20a%20crowded%20train%20carriage%20with%20panicked%20passengers%20silhouetted%20in%20red%20emergency%20lighting%2C%20gritty%20cinematic%20tones%2C%20vertical%20poster%2C%20high%20detail&width=600&height=900&seq=busan-poster&orientation=portrait",
    backdrop: "https://readdy.ai/api/search-image?query=dim%20abandoned%20train%20station%20platform%20with%20flickering%20lights%20and%20eerie%20fog%2C%20post%20apocalyptic%20horror%20atmosphere%2C%20wide%20shot%2C%20high%20detail&width=1920&height=1080&seq=busan-backdrop&orientation=landscape",
    synopsis: "一位自私的基金经理带女儿乘上开往釜山的高铁，不料车厢中爆发丧尸危机。在生死逃亡的路上，人性在恐惧中被反复考验。",
    heat: 745000,
    tags: ["丧尸", "灾难", "动作"],
  },
  {
    id: "your-name",
    type: "movie",
    title: "你的名字。",
    originalTitle: "君の名は。",
    year: 2016,
    region: "日韩",
    country: "日本",
    genres: ["动画", "爱情", "奇幻"],
    rating: 8.5,
    director: "新海诚",
    cast: ["神木隆之介", "上白石萌音"],
    duration: "106分钟",
    poster: "https://readdy.ai/api/search-image?query=beautiful%20anime%20movie%20poster%20of%20two%20teenagers%20standing%20apart%20under%20a%20vast%20starry%20sky%20with%20a%20glowing%20comet%2C%20romantic%20twilight%20gradient%20colors%2C%20vertical%20poster%2C%20high%20detail&width=600&height=900&seq=yourname-poster&orientation=portrait",
    backdrop: "https://readdy.ai/api/search-image?query=breathtaking%20anime%20landscape%20of%20a%20town%20lake%20at%20dusk%20with%20a%20brilliant%20comet%20streaking%20across%20purple%20orange%20sky%2C%20cinematic%20wide%20shot%2C%20high%20detail&width=1920&height=1080&seq=yourname-backdrop&orientation=landscape",
    synopsis: "住在深山小镇的少女三叶，与东京少年泷，在梦中交换了身体。随着联系加深，他们踏上寻找彼此的旅途，却撞见一个跨越时空的残酷真相。",
    heat: 889000,
    featured: true,
    tags: ["新海诚", "青春", "爱情"],
  },
  {
    id: "suzume",
    type: "movie",
    title: "铃芽之旅",
    originalTitle: "すずめの戸締まり",
    year: 2022,
    region: "日韩",
    country: "日本",
    genres: ["动画", "奇幻", "冒险"],
    rating: 7.4,
    director: "新海诚",
    cast: ["原菜乃华", "松村北斗", "深津绘里"],
    duration: "122分钟",
    poster: "https://readdy.ai/api/search-image?query=luminous%20anime%20movie%20poster%20of%20a%20young%20girl%20standing%20before%20a%20glowing%20rusty%20door%20in%20an%20open%20field%20under%20a%20wide%20sky%2C%20hope%20filled%20cinematic%20tones%2C%20vertical%20poster%2C%20high%20detail&width=600&height=900&seq=suzume-poster&orientation=portrait",
    backdrop: "https://readdy.ai/api/search-image?query=sweeping%20anime%20landscape%20of%20a%20coastal%20town%20and%20railway%20under%20a%20dramatic%20sky%20with%20soft%20golden%20light%2C%20cinematic%20wide%20shot%2C%20high%20detail&width=1920&height=1080&seq=suzume-backdrop&orientation=landscape",
    synopsis: "少女铃芽偶遇神秘的关门师，为了阻止灾厄从各地“废墟之门”涌现，她踏上跨越日本的旅程，也在途中寻回了关于母亲的记忆。",
    heat: 702000,
    tags: ["新海诚", "灾难", "公路"],
  },
  {
    id: "slam-dunk",
    type: "movie",
    title: "灌篮高手",
    originalTitle: "THE FIRST SLAM DUNK",
    year: 2022,
    region: "日韩",
    country: "日本",
    genres: ["动画", "运动", "剧情"],
    rating: 9.0,
    director: "井上雄彦",
    cast: ["仲村宗悟", "笠间淳", "神尾晋一郎"],
    duration: "124分钟",
    poster: "https://readdy.ai/api/search-image?query=dynamic%20anime%20sports%20movie%20poster%20of%20a%20basketball%20player%20mid%20jump%20shot%20in%20a%20packed%20arena%2C%20energetic%20warm%20lighting%20and%20motion%20lines%2C%20vertical%20poster%2C%20high%20detail&width=600&height=900&seq=slamdunk-poster&orientation=portrait",
    backdrop: "https://readdy.ai/api/search-image?query=energetic%20anime%20basketball%20court%20inside%20a%20large%20arena%20with%20blazing%20spotlights%20and%20cheering%20crowd%2C%20dynamic%20cinematic%20wide%20shot%2C%20high%20detail&width=1920&height=1080&seq=slamdunk-backdrop&orientation=landscape",
    synopsis: "湘北高中篮球队踏上全国大赛的舞台，宫城良田与队友们为了信念全力冲刺。每一记进球，都是青春最滚烫的注脚。",
    heat: 934000,
    featured: true,
    tags: ["热血", "篮球", "青春"],
  },
  {
    id: "burning",
    type: "movie",
    title: "燃烧",
    originalTitle: "버닝",
    year: 2018,
    region: "日韩",
    country: "韩国",
    genres: ["剧情", "悬疑", "爱情"],
    rating: 8.1,
    director: "李沧东",
    cast: ["刘亚仁", "史蒂文·元", "全钟瑞"],
    duration: "148分钟",
    poster: "https://readdy.ai/api/search-image?query=mysterious%20arthouse%20movie%20poster%20of%20a%20young%20man%20gazing%20into%20the%20distance%20with%20a%20faint%20orange%20glow%20on%20the%20horizon%2C%20melancholic%20dusk%20tones%2C%20vertical%20poster%2C%20high%20detail&width=600&height=900&seq=burning-poster&orientation=portrait",
    backdrop: "https://readdy.ai/api/search-image?query=atmospheric%20dusk%20rural%20landscape%20with%20a%20lone%20glowing%20orange%20fire%20in%20the%20far%20distance%2C%20melancholic%20cinematic%20mood%2C%20wide%20shot%2C%20high%20detail&width=1920&height=1080&seq=burning-backdrop&orientation=landscape",
    synopsis: "送快递的青年钟秀重逢童年玩伴惠美，而她身边多了一位神秘富有的男子本。三人之间暧昧而危险的三角关系，最终指向一个难以证实的消失与秘密。",
    heat: 512000,
    tags: ["悬疑", "文艺", "村上春树"],
  },
  {
    id: "weathering-with-you",
    type: "movie",
    title: "天气之子",
    originalTitle: "天気の子",
    year: 2019,
    region: "日韩",
    country: "日本",
    genres: ["动画", "爱情", "奇幻"],
    rating: 7.0,
    director: "新海诚",
    cast: ["醍醐虎汰朗", "森七菜", "本田翼"],
    duration: "112分钟",
    poster: "https://readdy.ai/api/search-image?query=romantic%20anime%20movie%20poster%20of%20a%20boy%20and%20girl%20standing%20on%20a%20rooftop%20under%20a%20rainbow%20sky%20with%20sunlight%20breaking%20through%20rain%20clouds%2C%20vivid%20cinematic%20colors%2C%20vertical%20poster%2C%20high%20detail&width=600&height=900&seq=weathering-poster&orientation=portrait",
    backdrop: "https://readdy.ai/api/search-image?query=stunning%20anime%20cityscape%20of%20Tokyo%20under%20dramatic%20rain%20clouds%20with%20sunbeams%20piercing%20through%2C%20cinematic%20wide%20shot%2C%20high%20detail&width=1920&height=1080&seq=weathering-backdrop&orientation=landscape",
    synopsis: "离家出走的少年帆高在东京遇见能让天空放晴的少女阳菜。两人在阴雨连绵的城市里相依为命，却逐渐触碰到改变天气所付出的代价。",
    heat: 623000,
    tags: ["新海诚", "奇幻", "雨天"],
  },
  {
    id: "shoplifters",
    type: "movie",
    title: "小偷家族",
    originalTitle: "万引き家族",
    year: 2018,
    region: "日韩",
    country: "日本",
    genres: ["剧情", "家庭", "犯罪"],
    rating: 8.7,
    director: "是枝裕和",
    cast: ["中川雅也", "安藤樱", "松冈茉优", "树木希林"],
    duration: "121分钟",
    poster: "https://readdy.ai/api/search-image?query=warm%20humanist%20movie%20poster%20of%20a%20family%20of%20six%20standing%20together%20in%20a%20cramped%20old%20Tokyo%20house%2C%20soft%20golden%20light%2C%20tender%20cinematic%20tones%2C%20vertical%20poster%2C%20high%20detail&width=600&height=900&seq=shoplifters-poster&orientation=portrait",
    backdrop: "https://readdy.ai/api/search-image?query=narrow%20old%20Japanese%20residential%20alley%20at%20dusk%20with%20warm%20window%20light%2C%20quiet%20humanist%20cinematic%20mood%2C%20wide%20shot%2C%20high%20detail&width=1920&height=1080&seq=shoplifters-backdrop&orientation=landscape",
    synopsis: "在东京的老旧平房里，靠偷窃和零工为生的“一家人”收留了一个冻僵的小女孩。他们彼此没有血缘，却在贫困中守着一份隐秘而温暖的羁绊。",
    heat: 578000,
    tags: ["金棕榈", "家庭", "治愈"],
  },
  {
    id: "stranger-things",
    type: "tv",
    title: "怪奇物语",
    originalTitle: "Stranger Things",
    year: 2016,
    endYear: 2025,
    region: "欧美",
    country: "美国",
    genres: ["科幻", "恐怖", "悬疑"],
    rating: 8.7,
    director: "达菲兄弟",
    cast: ["米莉·波比·布朗", "薇诺娜·瑞德", "大卫·哈伯"],
    episodes: 34,
    status: "连载",
    poster: "https://readdy.ai/api/search-image?query=retro%20eighties%20sci%20fi%20tv%20poster%20of%20a%20group%20of%20kids%20on%20bikes%20facing%20a%20glowing%20red%20rift%20in%20a%20dark%20forest%2C%20nostalgic%20neon%20tones%2C%20vertical%20poster%2C%20high%20detail&width=600&height=900&seq=stranger-poster&orientation=portrait",
    backdrop: "https://readdy.ai/api/search-image?query=eerie%20misty%20pine%20forest%20at%20night%20with%20a%20glowing%20red%20interdimensional%20crack%20in%20the%20sky%2C%20sci%20fi%20horror%20atmosphere%2C%20wide%20shot%2C%20high%20detail&width=1920&height=1080&seq=stranger-backdrop&orientation=landscape",
    synopsis: "1980年代的小镇霍金斯，一个男孩的神秘失踪揭开了一系列超自然事件。一群少年发现了一个拥有超能力的女孩，也撞见了潜藏在平静之下的黑暗实验。",
    heat: 968000,
    featured: true,
    tags: ["科幻", "80年代", "Netflix"],
  },
  {
    id: "the-crown",
    type: "tv",
    title: "王冠",
    originalTitle: "The Crown",
    year: 2016,
    endYear: 2023,
    region: "欧美",
    country: "英国",
    genres: ["历史", "剧情", "传记"],
    rating: 8.8,
    director: "彼得·摩根",
    cast: ["克莱尔·芙伊", "奥利维娅·科尔曼", "艾美达·斯丹顿"],
    episodes: 60,
    status: "完结",
    poster: "https://readdy.ai/api/search-image?query=regal%20historical%20drama%20tv%20poster%20of%20an%20elegant%20queen%20figure%20in%20a%20crown%20and%20formal%20attire%20in%20a%20palace%20hall%2C%20sumptuous%20golden%20lighting%2C%20vertical%20poster%2C%20high%20detail&width=600&height=900&seq=crown-poster&orientation=portrait",
    backdrop: "https://readdy.ai/api/search-image?query=grand%20opulent%20British%20palace%20interior%20with%20ornate%20gold%20details%20and%20soft%20daylight%2C%20majestic%20historical%20cinematic%20mood%2C%20wide%20shot%2C%20high%20detail&width=1920&height=1080&seq=crown-backdrop&orientation=landscape",
    synopsis: "本剧以伊丽莎白二世的一生为线索，展现英国王室数十年来在政治风云、家族纠葛与公众审视下的抉择与代价。",
    heat: 806000,
    tags: ["历史", "王室", "英剧"],
  },
  {
    id: "the-last-of-us",
    type: "tv",
    title: "最后生还者",
    originalTitle: "The Last of Us",
    year: 2023,
    endYear: 2025,
    region: "欧美",
    country: "美国",
    genres: ["剧情", "恐怖", "冒险"],
    rating: 8.7,
    director: "克雷格·麦辛",
    cast: ["佩德罗·帕斯卡", "贝拉·拉姆齐", "加布里埃尔·卢娜"],
    episodes: 16,
    status: "连载",
    poster: "https://readdy.ai/api/search-image?query=post%20apocalyptic%20tv%20poster%20of%20a%20rugged%20man%20and%20a%20young%20girl%20walking%20through%20overgrown%20ruined%20city%20streets%2C%20muted%20green%20gray%20tones%2C%20vertical%20poster%2C%20high%20detail&width=600&height=900&seq=lastofus-poster&orientation=portrait",
    backdrop: "https://readdy.ai/api/search-image?query=abandoned%20overgrown%20city%20skyline%20reclaimed%20by%20nature%20under%20a%20hazy%20sky%2C%20post%20apocalyptic%20cinematic%20atmosphere%2C%20wide%20shot%2C%20high%20detail&width=1920&height=1080&seq=lastofus-backdrop&orientation=landscape",
    synopsis: "在现代文明崩塌二十年后，走私客乔尔护送拥有免疫力的少女艾莉穿越废墟遍布的美国。两人在险境中建立起如同父女的羁绊。",
    heat: 852000,
    tags: ["末日", "冒险", "改编"],
  },
  {
    id: "house-of-the-dragon",
    type: "tv",
    title: "龙之家族",
    originalTitle: "House of the Dragon",
    year: 2022,
    endYear: 2024,
    region: "欧美",
    country: "美国",
    genres: ["奇幻", "剧情", "冒险"],
    rating: 8.4,
    director: "米格尔·萨普什尼克",
    cast: ["马特·史密斯", "艾玛·达西", "奥利维亚·库克"],
    episodes: 18,
    status: "连载",
    poster: "https://readdy.ai/api/search-image?query=epic%20fantasy%20tv%20poster%20of%20a%20woman%20in%20ornate%20royal%20armor%20standing%20before%20a%20massive%20dragon%20silhouette%2C%20fiery%20crimson%20tones%2C%20vertical%20poster%2C%20high%20detail&width=600&height=900&seq=hotd-poster&orientation=portrait",
    backdrop: "https://readdy.ai/api/search-image?query=dramatic%20fantasy%20scene%20of%20a%20castle%20with%20dragons%20circling%20above%20fiery%20crimson%20sky%2C%20epic%20cinematic%20wide%20shot%2C%20high%20detail&width=1920&height=1080&seq=hotd-backdrop&orientation=landscape",
    synopsis: "《权力的游戏》两百年前，坦格利安家族的权力斗争点燃了血与火的“巨龙之舞”。王位继承的裂痕，将整个维斯特洛拖入内战的深渊。",
    heat: 839000,
    tags: ["奇幻", "权游前传", "巨龙"],
  },
  {
    id: "succession",
    type: "tv",
    title: "继承之战",
    originalTitle: "Succession",
    year: 2018,
    endYear: 2023,
    region: "欧美",
    country: "美国",
    genres: ["剧情", "喜剧", "家庭"],
    rating: 8.9,
    director: "杰西·阿姆斯特朗",
    cast: ["布莱恩·考克斯", "杰瑞米·斯特朗", "莎拉·斯努克"],
    episodes: 39,
    status: "完结",
    poster: "https://readdy.ai/api/search-image?query=sharp%20corporate%20drama%20tv%20poster%20of%20a%20family%20of%20powerful%20business%20people%20in%20dark%20tailored%20suits%20against%20a%20moody%20gray%20high%20rise%20backdrop%2C%20cold%20elegant%20tones%2C%20vertical%20poster%2C%20high%20detail&width=600&height=900&seq=succession-poster&orientation=portrait",
    backdrop: "https://readdy.ai/api/search-image?query=sleek%20modern%20corporate%20boardroom%20with%20floor%20to%20ceiling%20windows%20overlooking%20a%20gray%20city%2C%20cold%20power%20cinematic%20mood%2C%20wide%20shot%2C%20high%20detail&width=1920&height=1080&seq=succession-backdrop&orientation=landscape",
    synopsis: "传媒帝国年迈的掌权者健康状况堪忧，四个子女为争夺继承权彼此算计。家族的温情在野心与利益面前，被撕扯得所剩无几。",
    heat: 701000,
    tags: ["商战", "家族", "HBO"],
  },
  {
    id: "the-mandalorian",
    type: "tv",
    title: "曼达洛人",
    originalTitle: "The Mandalorian",
    year: 2019,
    endYear: 2023,
    region: "欧美",
    country: "美国",
    genres: ["科幻", "动作", "冒险"],
    rating: 8.7,
    director: "乔恩·费儒",
    cast: ["佩德罗·帕斯卡", "卡尔·韦瑟斯", "吉娜·卡拉诺"],
    episodes: 24,
    status: "完结",
    poster: "https://readdy.ai/api/search-image?query=space%20western%20tv%20poster%20of%20a%20lone%20armored%20bounty%20hunter%20in%20a%20silver%20helmet%20with%20a%20tiny%20green%20alien%20child%20in%20a%20pouch%2C%20dusty%20warm%20tones%2C%20vertical%20poster%2C%20high%20detail&width=600&height=900&seq=mandalorian-poster&orientation=portrait",
    backdrop: "https://readdy.ai/api/search-image?query=alien%20desert%20planet%20landscape%20with%20twin%20suns%20setting%20behind%20rocky%20mesas%2C%20star%20wars%20space%20western%20cinematic%20mood%2C%20wide%20shot%2C%20high%20detail&width=1920&height=1080&seq=mandalorian-backdrop&orientation=landscape",
    synopsis: "一位独行的曼达洛赏金猎人接下一项神秘委托，却发现目标是一个拥有原力的婴儿。为了保护这个孩子，他踏上穿越银河边缘的冒险。",
    heat: 788000,
    tags: ["星战", "太空", "萌娃"],
  },
  {
    id: "wednesday",
    type: "tv",
    title: "星期三",
    originalTitle: "Wednesday",
    year: 2022,
    endYear: 2025,
    region: "欧美",
    country: "美国",
    genres: ["喜剧", "奇幻", "悬疑"],
    rating: 8.1,
    director: "蒂姆·伯顿",
    cast: ["珍娜·奥尔特加", "凯瑟琳·泽塔-琼斯", "路易斯·古兹曼"],
    episodes: 16,
    status: "连载",
    poster: "https://readdy.ai/api/search-image?query=gothic%20dark%20comedy%20tv%20poster%20of%20a%20pale%20girl%20with%20two%20dark%20braids%20in%20a%20black%20school%20uniform%20standing%20in%20a%20gloomy%20manor%2C%20eerie%20monochrome%20tones%2C%20vertical%20poster%2C%20high%20detail&width=600&height=900&seq=wednesday-poster&orientation=portrait",
    backdrop: "https://readdy.ai/api/search-image?query=gothic%20spooky%20academy%20building%20surrounded%20by%20bare%20trees%20and%20mist%20at%20twilight%2C%20tim%20burton%20eerie%20cinematic%20mood%2C%20wide%20shot%2C%20high%20detail&width=1920&height=1080&seq=wednesday-backdrop&orientation=landscape",
    synopsis: "亚当斯家古怪的少女星期三被转入奈弗莫尔学院，她一边应付复杂的校园人际关系，一边卷入一场与怪物有关的连环谜案。",
    heat: 726000,
    tags: ["哥特", "悬疑", "亚当斯"],
  },
  {
    id: "better-call-saul",
    type: "tv",
    title: "风骚律师",
    originalTitle: "Better Call Saul",
    year: 2015,
    endYear: 2022,
    region: "欧美",
    country: "美国",
    genres: ["犯罪", "剧情", "法律"],
    rating: 9.3,
    director: "文斯·吉利根",
    cast: ["鲍勃·奥登科克", "乔纳森·班克斯", "蕾亚·塞洪"],
    episodes: 63,
    status: "完结",
    poster: "https://readdy.ai/api/search-image?query=stylish%20legal%20crime%20drama%20tv%20poster%20of%20a%20slick%20lawyer%20in%20a%20colorful%20suit%20holding%20a%20briefcase%20under%20desert%20sunlight%2C%20warm%20amber%20tones%2C%20vertical%20poster%2C%20high%20detail&width=600&height=900&seq=saul-poster&orientation=portrait",
    backdrop: "https://readdy.ai/api/search-image?query=sun%20bleached%20new%20mexico%20desert%20highway%20with%20distant%20mesas%20under%20a%20vast%20blue%20sky%2C%20neo%20western%20cinematic%20mood%2C%20wide%20shot%2C%20high%20detail&width=1920&height=1080&seq=saul-backdrop&orientation=landscape",
    synopsis: "在小律师吉米·麦吉尔蜕变为“索尔·古德曼”的漫长道路上，理想与良知被一点点消磨。这是一部关于野心、堕落与代价的前传杰作。",
    heat: 693000,
    tags: ["神剧", "犯罪", "绝命毒师"],
  },
  {
    id: "squid-game",
    type: "tv",
    title: "鱿鱼游戏",
    originalTitle: "오징어 게임",
    year: 2021,
    endYear: 2024,
    region: "日韩",
    country: "韩国",
    genres: ["悬疑", "惊悚", "剧情"],
    rating: 7.8,
    director: "黄东赫",
    cast: ["李政宰", "朴海秀", "郑好娟", "李秉宪"],
    episodes: 16,
    status: "完结",
    poster: "https://readdy.ai/api/search-image?query=striking%20korean%20thriller%20tv%20poster%20of%20a%20player%20in%20a%20green%20tracksuit%20surrounded%20by%20huge%20pink%20guards%20with%20geometric%20masks%2C%20high%20contrast%20tones%2C%20vertical%20poster%2C%20high%20detail&width=600&height=900&seq=squidgame-poster&orientation=portrait",
    backdrop: "https://readdy.ai/api/search-image?query=surreal%20colorful%20playground%20with%20giant%20staircases%20painted%20in%20pastel%20pinks%20and%20mint%20greens%2C%20ominous%20cinematic%20mood%2C%20wide%20shot%2C%20high%20detail&width=1920&height=1080&seq=squidgame-backdrop&orientation=landscape",
    synopsis: "走投无路的一群人被邀请参加神秘生存游戏，胜者可赢取巨额奖金，失败者则要付出生命。人性的贪婪与善意在游戏中被无限放大。",
    heat: 951000,
    featured: true,
    tags: ["生存游戏", "韩国", "Netflix"],
  },
  {
    id: "the-glory",
    type: "tv",
    title: "黑暗荣耀",
    originalTitle: "더 글로리",
    year: 2022,
    endYear: 2023,
    region: "日韩",
    country: "韩国",
    genres: ["剧情", "复仇", "悬疑"],
    rating: 8.9,
    director: "安吉镐",
    cast: ["宋慧乔", "李到晛", "林智妍", "郑星一"],
    episodes: 16,
    status: "完结",
    poster: "https://readdy.ai/api/search-image?query=stylish%20dark%20korean%20revenge%20drama%20tv%20poster%20of%20an%20elegant%20woman%20in%20a%20black%20coat%20standing%20in%20cold%20winter%20light%2C%20moody%20blue%20gray%20tones%2C%20vertical%20poster%2C%20high%20detail&width=600&height=900&seq=theglory-poster&orientation=portrait",
    backdrop: "https://readdy.ai/api/search-image?query=melancholy%20quiet%20city%20street%20in%20winter%20dusk%20with%20soft%20falling%20snow%2C%20restrained%20cinematic%20mood%2C%20wide%20shot%2C%20high%20detail&width=1920&height=1080&seq=theglory-backdrop&orientation=landscape",
    synopsis: "少女时期遭受残酷校园暴力的文东恩，把仇恨熬成复仇的计划。多年后，她成为加害者孩子的班主任，一场冷静而漫长的清算正式开始。",
    heat: 917000,
    featured: true,
    tags: ["复仇", "宋慧乔", "校园暴力"],
  },
  {
    id: "my-liberation-notes",
    type: "tv",
    title: "我的解放日志",
    originalTitle: "나의 해방일지",
    year: 2022,
    region: "日韩",
    country: "韩国",
    genres: ["剧情", "家庭", "治愈"],
    rating: 9.2,
    director: "金锡允",
    cast: ["李民基", "金智媛", "孙锡久", "李起雨"],
    episodes: 16,
    status: "完结",
    poster: "https://readdy.ai/api/search-image?query=gentle%20korean%20slice%20of%20life%20tv%20poster%20of%20three%20siblings%20walking%20home%20along%20a%20quiet%20country%20road%20at%20dusk%2C%20soft%20muted%20tones%2C%20vertical%20poster%2C%20high%20detail&width=600&height=900&seq=liberation-poster&orientation=portrait",
    backdrop: "https://readdy.ai/api/search-image?query=serene%20korean%20suburban%20village%20with%20low%20houses%20and%20golden%20evening%20light%20over%20green%20fields%2C%20calm%20cinematic%20mood%2C%20wide%20shot%2C%20high%20detail&width=1920&height=1080&seq=liberation-backdrop&orientation=landscape",
    synopsis: "住在京畿道郊外的三兄妹，每天通勤往返于城市与乡村之间，被生活压得喘不过气。他们各自寻找着属于自己的“解放”，也慢慢学会与平凡和解。",
    heat: 664000,
    tags: ["治愈", "都市", "口碑神剧"],
  },
  {
    id: "brush-up-life",
    type: "tv",
    title: "重启人生",
    originalTitle: "ブラッシュアップライフ",
    year: 2023,
    region: "日韩",
    country: "日本",
    genres: ["喜剧", "奇幻", "剧情"],
    rating: 9.3,
    director: "水野格",
    cast: ["安藤樱", "夏帆", "木南晴夏", "水川麻美"],
    episodes: 10,
    status: "完结",
    poster: "https://readdy.ai/api/search-image?query=quirky%20japanese%20comedy%20drama%20tv%20poster%20of%20a%20cheerful%20young%20woman%20surrounded%20by%20floating%20colorful%20playful%20graphic%20elements%2C%20bright%20light%20tones%2C%20vertical%20poster%2C%20high%20detail&width=600&height=900&seq=brushup-poster&orientation=portrait",
    backdrop: "https://readdy.ai/api/search-image?query=cheerful%20japanese%20suburban%20neighborhood%20with%20cherry%20blossoms%20and%20clear%20blue%20sky%2C%20bright%20optimistic%20cinematic%20mood%2C%20wide%20shot%2C%20high%20detail&width=1920&height=1080&seq=brushup-backdrop&orientation=landscape",
    synopsis: "普通得不能再普通的近藤麻美，意外死后被告知为了投胎成人必须积攒功德。她一次次重启人生，只为守护身边珍视的人。",
    heat: 611000,
    tags: ["重生", "友情", "日剧"],
  },
  {
    id: "first-love",
    type: "tv",
    title: "初恋",
    originalTitle: "First Love",
    year: 2022,
    region: "日韩",
    country: "日本",
    genres: ["爱情", "剧情"],
    rating: 8.4,
    director: "寒竹百合",
    cast: ["满岛光", "佐藤健", "八木莉可子"],
    episodes: 9,
    status: "完结",
    poster: "https://readdy.ai/api/search-image?query=romantic%20japanese%20tv%20poster%20of%20a%20young%20couple%20in%20winter%20coats%20standing%20under%20falling%20snow%20with%20bokeh%20city%20lights%2C%20dreamy%20soft%20tones%2C%20vertical%20poster%2C%20high%20detail&width=600&height=900&seq=firstlove-poster&orientation=portrait",
    backdrop: "https://readdy.ai/api/search-image?query=romantic%20snowy%20japanese%20street%20at%20night%20with%20warm%20bokeh%20shop%20lights%20and%20falling%20snow%2C%20dreamy%20cinematic%20mood%2C%20wide%20shot%2C%20high%20detail&width=1920&height=1080&seq=firstlove-backdrop&orientation=landscape",
    synopsis: "一段跨越二十年的初恋，在漫天飞雪的北海道开始，也在命运的辗转中重逢。时间带走了许多，却没能带走那年心动的记忆。",
    heat: 632000,
    tags: ["纯爱", "日剧", "回忆"],
  },
  {
    id: "hanzawa-naoki",
    type: "tv",
    title: "半泽直树",
    originalTitle: "半沢直樹",
    year: 2013,
    endYear: 2020,
    region: "日韩",
    country: "日本",
    genres: ["剧情", "职场"],
    rating: 9.3,
    director: "福泽克雄",
    cast: ["堺雅人", "上户彩", "香川照之", "及川光博"],
    episodes: 20,
    status: "完结",
    poster: "https://readdy.ai/api/search-image?query=intense%20japanese%20corporate%20drama%20tv%20poster%20of%20a%20determined%20banker%20in%20a%20dark%20suit%20adjusting%20his%20glasses%20with%20fiery%20resolve%2C%20dramatic%20tones%2C%20vertical%20poster%2C%20high%20detail&width=600&height=900&seq=hanzawa-poster&orientation=portrait",
    backdrop: "https://readdy.ai/api/search-image?query=grand%20modern%20tokyo%20bank%20tower%20lobby%20with%20polished%20marble%20and%20cold%20lighting%2C%20tense%20corporate%20cinematic%20mood%2C%20wide%20shot%2C%20high%20detail&width=1920&height=1080&seq=hanzawa-backdrop&orientation=landscape",
    synopsis: "银行职员半泽直树坚信“以牙还牙，加倍奉还”。面对上司的陷害与职场的倾轧，他凭借过人的智慧与信念，向庞大而腐朽的体制发起挑战。",
    heat: 705000,
    tags: ["职场", "热血", "口碑"],
  },
  {
    id: "stranger-forest",
    type: "tv",
    title: "秘密森林",
    originalTitle: "비밀의 숲",
    year: 2017,
    endYear: 2020,
    region: "日韩",
    country: "韩国",
    genres: ["犯罪", "悬疑", "剧情"],
    rating: 9.0,
    director: "安吉镐",
    cast: ["曹承佑", "裴斗娜", "李浚赫"],
    episodes: 32,
    status: "完结",
    poster: "https://readdy.ai/api/search-image?query=tense%20korean%20crime%20thriller%20tv%20poster%20of%20a%20stoic%20prosecutor%20in%20a%20dark%20coat%20standing%20in%20a%20rainy%20night%20street%2C%20cold%20noir%20tones%2C%20vertical%20poster%2C%20high%20detail&width=600&height=900&seq=forest-poster&orientation=portrait",
    backdrop: "https://readdy.ai/api/search-image?query=moody%20rainy%20seoul%20city%20street%20at%20night%20with%20wet%20reflections%20and%20cold%20blue%20light%2C%20noir%20cinematic%20mood%2C%20wide%20shot%2C%20high%20detail&width=1920&height=1080&seq=forest-backdrop&orientation=landscape",
    synopsis: "因手术失去情感的检察官黄始木，与热血刑警韩汝珍联手追查一桩命案。线索层层剥开，指向一张盘踞在权力深处的庞大腐败之网。",
    heat: 588000,
    tags: ["犯罪", "推理", "神剧"],
  },
  {
    id: "moving",
    type: "tv",
    title: "超异能族",
    originalTitle: "무빙",
    year: 2023,
    region: "日韩",
    country: "韩国",
    genres: ["科幻", "动作", "剧情"],
    rating: 8.6,
    director: "朴仁载",
    cast: ["柳承龙", "韩孝周", "赵寅成", "李政夏"],
    episodes: 20,
    status: "连载",
    poster: "https://readdy.ai/api/search-image?query=superhero%20korean%20tv%20poster%20of%20a%20teenage%20boy%20floating%20above%20a%20city%20skyline%20at%20dawn%2C%20cinematic%20moody%20blue%20tones%2C%20vertical%20poster%2C%20high%20detail&width=600&height=900&seq=moving-poster&orientation=portrait",
    backdrop: "https://readdy.ai/api/search-image?query=dramatic%20city%20skyline%20at%20blue%20hour%20seen%20from%20high%20above%20the%20clouds%2C%20superhero%20cinematic%20mood%2C%20wide%20shot%2C%20high%20detail&width=1920&height=1080&seq=moving-backdrop&orientation=landscape",
    synopsis: "一群过着平凡生活的孩子，隐藏着飞行、再生、超强感官等秘密能力。为了保护孩子，曾拥有超能力的父母们不得不直面来自过去的追杀。",
    heat: 677000,
    tags: ["超能力", "家庭", "韩国"],
  },
];